import { SessionStatus } from '../../constants';
import { useLogReportedRefreshError } from './utils/useLogReportedRefreshError';
import { useDecideIfLoginIsRequired } from './utils/useDecideIfLoginIsRequired';

export const useWithAuthState = ({
    forceAuth,
    serverSideSessionStatus,
}: {
    forceAuth: boolean;
    serverSideSessionStatus: SessionStatus | null;
}) => {
    const { error, session, status, isAuthenticationDecisionPending } = useDecideIfLoginIsRequired(
        forceAuth,
        serverSideSessionStatus
    );

    useLogReportedRefreshError(session);

    if (error) {
        // allow our React error boundaries to handle any errors, should they occur
        // (instead of swallowing promise rejections encountered during useEffect's async calls)
        throw error;
    }

    return { isAuthenticationDecisionPending, status, session };
};
